module.exports = "/wwwroot/img/KML.png?ver=c814d01f";